module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8701/img/iphone-frame.png"